import { render, staticRenderFns } from "./imprimir-pauta-custom_2020.vue?vue&type=template&id=6464fea4&"
import script from "./imprimir-pauta-custom_2020.vue?vue&type=script&lang=js&"
export * from "./imprimir-pauta-custom_2020.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports